import React from 'react';
import SelectField from '../components/SelectField';
import ScrollToTop from '../components/ScrollToTop';
import SocialBlock from '../components/SocialBlock';
import SEO from '../components/SEO';
import CTA from '../components/CTA';
import { contactData } from '../static/data';
import '../css/contact.css';
import '../css/form.css';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { ContactFormSchema } from '../utils/validationSchema';
import { contactTopicOptions } from '../static/formOptions';

import { submitContactForm } from '../actions/formActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const _ContactForm = ({ submitContactForm }) => {
  return (
    <Formik
      initialValues={{
        name: '',
        email: '',
        phone: '',
        inquireAbout: '',
        message: ''
      }}
      validationSchema={ContactFormSchema}
      onSubmit={(values, actions) => {
        return submitContactForm(values).then((ret) => {
          if (ret && ret.payload) {
            actions.resetForm();
            actions.setStatus({
              success: "Submitted Successfully! We'll reach out to you shortly"
            });
            // make success message disappear
            setTimeout(() => actions.setStatus({ success: '' }), 6000);
          } else {
            actions.setStatus({
              success:
                'There was an error submitting your request. Try again later.'
            });
          }
        });
      }}
      render={({ status, isSubmitting }) => (
        <Form id="contactForm" className="form">
          <h1 className="text-light">Send us a message</h1>
          <fieldset>
            <label>Name</label>
            <Field type="text" name="name" placeholder="Enter your name" />
            <ErrorMessage name="name" component="div" className="error" />
          </fieldset>
          <fieldset>
            <label>Email</label>
            <Field type="email" name="email" placeholder="Enter your email" />
            <ErrorMessage name="email" component="div" className="error" />
          </fieldset>
          <fieldset>
            <label>Phone</label>
            <Field
              type="text"
              name="phone"
              placeholder="Enter your phone number"
            />
            <ErrorMessage name="phone" component="div" className="error" />
          </fieldset>
          <fieldset>
            <label>What would you like to know about?</label>
            <Field
              className="select-box"
              name="inquireAbout"
              options={contactTopicOptions}
              component={SelectField}
              placeholder="Select..."
              theme={(theme) => ({
                ...theme,
                borderRadius: '10px',
                colors: {
                  ...theme.colors,
                  primary25: '#FAFAFA',
                  primary: '#3DA6FC'
                }
              })}
            />
            <ErrorMessage
              name="inquireAbout"
              component="div"
              className="error"
            />
          </fieldset>
          <fieldset>
            <label>Message</label>
            <Field
              name="message"
              component="textarea"
              placeholder="Type here..."
              rows={7}
              className="text-light"
            />
            <ErrorMessage name="message" component="div" className="error" />
          </fieldset>
          {status && status.success && (
            <div className="success">{status.success}</div>
          )}
          <button
            className="btn btn-filled btn-filled-yellow"
            type="submit"
            disabled={isSubmitting}
          >
            Send
          </button>
        </Form>
      )}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitContactForm
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {};
}

const ContactForm = connect(mapStateToProps, mapDispatchToProps)(_ContactForm);

function Contact() {
  return (
    <>
      <SEO
        title="WE3 Academy | Coding Bootcamp | Contact Us"
        description="We are creating a community of developers, designers, and entrepreneurs by bridging the gap between education and employability. Feel free to reach out if you have any suggestions, queries, and ideas for us."
        keywords="WE3 Academy, WE3, Coding Bootcamp, web development bootcamp, education, best coding bootcamp, coding bootcamp in India, coding bootcamp in mumbai, best coding bootcamp in mumbai, programming bootcamp, full stack web development course, full stack web development, dev bootcamp, career courses, digital courses, course, courses, career development, career development course, social media marketing, social media marketing course, social media, best courses in mumbai, social media courses in mumbai, career development courses in mumbai, part time courses, part time course, full time courses, computer programming, computer coding, training courses, training, in-person training, real world experiences, real work environment,"
        link="/contact"
      />
      <div id="contact">
        <ScrollToTop />
        <div className="contact__main">
          <ContactForm />
          <div className="contact__main-info">
            <h1 className="text-light">Call</h1>
            <h2 className="yellow">
              <a href={`tel:${contactData.phone}`}>{contactData.phone}</a>
            </h2>

            <h1 className="text-light">Email</h1>
            <h2 className="yellow">
              <a href={`mailto:${contactData.email}`}>{contactData.email}</a>
            </h2>

            <h1 className="text-light">Or Drop By Our Office</h1>
            <div style={{ height: '300px', width: '100%' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.1438246055945!2d72.86895071538548!3d19.232562652029273!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b111b7ade465%3A0xd3498ec70ac1529a!2sWE3%20Academy!5e0!3m2!1sen!2sin!4v1570607396715!5m2!1sen!2sin"
                width="100%"
                height="300"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen={false}
                title="WE3 Academy Address"
              ></iframe>
            </div>
            <p className="text-light">{contactData.address}</p>
          </div>
        </div>

        {/* <CTA styleType="style2" /> */}
        <CTA styleType="style5" />
        <SocialBlock styleType="style1" />
      </div>
    </>
  );
}

export default Contact;
